module.exports = __webpack_public_path__ + "img/arrow_left.94856e20.svg";